export default function displayValuesFor(props, moreProps) {
	const { currentItem } = moreProps;
	return currentItem;
}
